export enum RoutesNames {
  AllocationsInventoryApproved = 'allocations.inventory.approved',
  AllocationsInventoryPending = 'allocations.inventory.pending',
  AllocationInventoryScheduled = 'allocations.inventory.scheduled',
  AllocationsProductLocationApproved = 'allocations.productLocation.approved',
  AllocationsProductLocationPending = 'allocations.productLocation.pending',
  AllocationsProductLocationScheduled = 'allocations.productLocation.scheduled',
  AllocationsUpload = 'allocations.upload',

  DataCenterDownloads = 'dataCenter.downloads',
  DataCenterUploads = 'dataCenter.uploads',

  InventoryInventories = 'inventory.inventories',
  InventorySkus = 'inventory.skus',
  InventoryLocations = 'inventory.locations',
  InventoryTransactions = 'inventory.transactions',
  InventoryProductLocations = 'inventory.productLocations',

  InventoryManagement = 'inventoryManagement',

  SpecialEvents = 'specialEvents',
  SpecialEventsPending = 'specialEvents.pending',
  SpecialEventsApproved = 'specialEvents.approved',
  SpecialEventsUpcoming = 'specialEvents.upcoming',
  SpecialEventsUpload = 'specialEvents.upload',
  SpecialEventsAnalysis = 'specialEvents.analysis',
  SpecialEventsUploadPage = 'specialEvents.uploadPage',

  StoreTransferRecommendationsTrips = 'storeTransfer.recommendations.trips',
  StoreTransferRecommendationsProducts = 'storeTransfer.recommendations.products',
}
